export const notificationCenter = {
  markAsRead: "既読にする",
  activity: "アクティビティ",
  read: "既読",
  unread: "未読",
};
